/* ============================================================
   BRACELET FILTER — bracelet-filter.js
   assets/bracelet-filter.js
   ============================================================ */

(function () {
  'use strict';

  var grid = document.getElementById('bf-grid');
  if (!grid) return;

  var drawer        = document.getElementById('bf-drawer');
  var overlay       = document.getElementById('bf-overlay');
  var openBtn       = document.getElementById('bf-open-drawer');
  var closeBtn      = document.getElementById('bf-drawer-close');
  var applyBtn      = document.getElementById('bf-drawer-apply');
  var searchInput   = document.getElementById('bf-search');
  var inputMin      = document.getElementById('bf-input-min');
  var inputMax      = document.getElementById('bf-input-max');
  var labelMin      = document.getElementById('bf-label-min');
  var labelMax      = document.getElementById('bf-label-max');
  var priceFill     = document.getElementById('bf-price-fill');
  var resetBtn      = document.getElementById('bf-reset');
  var resetEmpty    = document.getElementById('bf-reset-empty');
  var countEl       = document.getElementById('bf-count');
  var countMobile   = document.getElementById('bf-count-mobile');
  var emptyState    = document.getElementById('bf-empty');
  var filterBadge   = document.getElementById('bf-filter-badge');
  var sidebarMirror = document.getElementById('bf-sidebar-mirror');
  var viewBtns      = document.querySelectorAll('.bf-view-btn');
  var cards         = document.querySelectorAll('.bf-card');

  // ── Prix réels ───────────────────────────────────────────
  var globalMax = 0;
  cards.forEach(function (card) {
    var price = (parseInt(card.dataset.price) || 0) / 100;
    if (price > globalMax) globalMax = price;
  });
  globalMax = Math.ceil(globalMax) || 100;

  inputMin.max = globalMax; inputMin.value = 0;
  inputMax.max = globalMax; inputMax.value = globalMax;
  updatePriceBar(0, globalMax);
  if (labelMin) labelMin.textContent = '0 €';
  if (labelMax) labelMax.textContent = globalMax + ' €';

  // ── État ─────────────────────────────────────────────────
  var state = {
    query:    '',
    priceMin: 0,
    priceMax: globalMax,
    tailles:  [],
    pierres:  [],
    genre:    '',   // '' | 'femme' | 'homme' | 'mixte'
  };

  // ══════════════════════════════════════════════════════════
  // GENRE PILLS — drawer + sidebar (délégation d'événement)
  // ══════════════════════════════════════════════════════════
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.bf-genre-pill');
    if (!pill) return;

    // Désactiver tous les pills du même conteneur parent
    var container = pill.closest('.bf-genre-pills');
    if (container) {
      container.querySelectorAll('.bf-genre-pill').forEach(function (p) {
        p.classList.remove('active');
      });
    }
    // Et aussi synchroniser l'autre conteneur (drawer <-> sidebar)
    document.querySelectorAll('.bf-genre-pill[data-genre="' + pill.dataset.genre + '"]').forEach(function (p) {
      p.classList.add('active');
    });
    document.querySelectorAll('.bf-genre-pill:not([data-genre="' + pill.dataset.genre + '"])').forEach(function (p) {
      if (p.dataset.genre !== pill.dataset.genre) p.classList.remove('active');
    });

    state.genre = pill.dataset.genre || '';
    applyFilters();
  });

  // ══════════════════════════════════════════════════════════
  // SIDEBAR DESKTOP
  // ══════════════════════════════════════════════════════════
  if (sidebarMirror && drawer) {
    var drawerInner = drawer.querySelectorAll('.bf-filter-block, .bf-reset-btn');
    drawerInner.forEach(function (el) {
      var clone = el.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      clone.removeAttribute('id');
      sidebarMirror.appendChild(clone);
    });

    // Checkboxes clonées
    sidebarMirror.querySelectorAll('.bf-filter-check').forEach(function (clonedCb) {
      clonedCb.addEventListener('change', function () {
        drawer.querySelectorAll(
          '.bf-filter-check[data-filter-type="' + clonedCb.dataset.filterType + '"][value="' + clonedCb.value + '"]'
        ).forEach(function (real) { real.checked = clonedCb.checked; });
        syncCheckboxState(clonedCb.dataset.filterType, clonedCb.value, clonedCb.checked);
        applyFilters();
      });
    });

    // Reset cloné
    var clonedReset = sidebarMirror.querySelector('.bf-reset-btn');
    if (clonedReset) clonedReset.addEventListener('click', doReset);

    // Accordéons clonés
    sidebarMirror.querySelectorAll('.bf-filter-label[data-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('.bf-filter-body');
        if (!body) return;
        var isOpen = body.classList.toggle('open');
        btn.classList.toggle('open', isOpen);
      });
    });

    // Recherche clonée
    var clonedSearch = sidebarMirror.querySelector('.bf-search-input');
    if (clonedSearch) {
      clonedSearch.addEventListener('input', function () {
        state.query = this.value.trim().toLowerCase();
        if (searchInput) searchInput.value = this.value;
        applyFilters();
      });
    }

    // Prix sidebar
    var clonedPriceRange = sidebarMirror.querySelector('.bf-price-range');
    if (clonedPriceRange) {
      clonedPriceRange.innerHTML =
        '<div class="bf-sidebar-price-row">' +
          '<input type="number" class="bf-price-input-num" id="sf-min" min="0" max="' + globalMax + '" value="0" placeholder="Min"/>' +
          '<span class="bf-price-sep">–</span>' +
          '<input type="number" class="bf-price-input-num" id="sf-max" min="0" max="' + globalMax + '" value="' + globalMax + '" placeholder="Max"/>' +
        '</div>';

      var sfMin = clonedPriceRange.querySelector('#sf-min');
      var sfMax = clonedPriceRange.querySelector('#sf-max');

      function syncSidebarPrice() {
        var mn = Math.min(parseInt(sfMin.value) || 0, parseInt(sfMax.value) || globalMax);
        var mx = Math.max(parseInt(sfMin.value) || 0, parseInt(sfMax.value) || globalMax);
        state.priceMin = mn;
        state.priceMax = mx;
        if (inputMin) inputMin.value = mn;
        if (inputMax) inputMax.value = mx;
        updatePriceBar(mn, mx);
        applyFilters();
      }
      sfMin.addEventListener('input', syncSidebarPrice);
      sfMax.addEventListener('input', syncSidebarPrice);
    }
  }

  // ══════════════════════════════════════════════════════════
  // DRAWER MOBILE
  // ══════════════════════════════════════════════════════════
  function openDrawerFn()  {
    if (!drawer || !overlay) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawerFn() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawerFn);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawerFn);
  if (overlay)  overlay.addEventListener('click', closeDrawerFn);
  if (applyBtn) applyBtn.addEventListener('click', function () {
    closeDrawerFn();
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawerFn(); });

  // ══════════════════════════════════════════════════════════
  // ACCORDÉONS (drawer)
  // ══════════════════════════════════════════════════════════
  if (drawer) {
    drawer.querySelectorAll('.bf-filter-label[data-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = document.getElementById(btn.dataset.target);
        if (!body) return;
        var isOpen = body.classList.toggle('open');
        btn.classList.toggle('open', isOpen);
      });
    });
  }

  // ══════════════════════════════════════════════════════════
  // RECHERCHE
  // ══════════════════════════════════════════════════════════
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.query = this.value.trim().toLowerCase();
      applyFilters();
    });
  }

  // ══════════════════════════════════════════════════════════
  // PRIX
  // ══════════════════════════════════════════════════════════
  function clamp(val, mn, mx) { return Math.max(mn, Math.min(mx, val)); }

  if (inputMin) {
    inputMin.addEventListener('input', function () {
      state.priceMin = clamp(parseInt(this.value) || 0, 0, globalMax);
      updatePriceBar(state.priceMin, state.priceMax);
      applyFilters();
    });
  }
  if (inputMax) {
    inputMax.addEventListener('input', function () {
      state.priceMax = clamp(parseInt(this.value) || 0, 0, globalMax);
      updatePriceBar(state.priceMin, state.priceMax);
      applyFilters();
    });
  }

  function updatePriceBar(mn, mx) {
    if (!priceFill) return;
    var range = globalMax || 1;
    priceFill.style.left  = (mn / range * 100) + '%';
    priceFill.style.right = ((globalMax - mx) / range * 100) + '%';
    if (labelMin) labelMin.textContent = mn + ' €';
    if (labelMax) labelMax.textContent = mx + ' €';
  }

  // ══════════════════════════════════════════════════════════
  // CHECKBOXES
  // ══════════════════════════════════════════════════════════
  if (drawer) {
    drawer.querySelectorAll('.bf-filter-check').forEach(function (cb) {
      cb.addEventListener('change', function () {
        syncCheckboxState(cb.dataset.filterType, cb.value, cb.checked);
        if (sidebarMirror) {
          sidebarMirror.querySelectorAll(
            '.bf-filter-check[data-filter-type="' + cb.dataset.filterType + '"][value="' + cb.value + '"]'
          ).forEach(function (sc) { sc.checked = cb.checked; });
        }
        applyFilters();
      });
    });
  }

  function syncCheckboxState(type, val, checked) {
    if (type === 'taille') updateArray(state.tailles, val, checked);
    else if (type === 'pierre') updateArray(state.pierres, val, checked);
  }

  function updateArray(arr, val, add) {
    var idx = arr.indexOf(val);
    if (add && idx === -1) arr.push(val);
    if (!add && idx !== -1) arr.splice(idx, 1);
  }

  // ══════════════════════════════════════════════════════════
  // FILTRAGE
  // ══════════════════════════════════════════════════════════
  function applyFilters() {
    var visible = 0;
    var mn = Math.min(state.priceMin, state.priceMax);
    var mx = Math.max(state.priceMin, state.priceMax);

    cards.forEach(function (card) {
      var title   = card.dataset.title   || '';
      var price   = (parseInt(card.dataset.price) || 0) / 100;
      var tailles = card.dataset.tailles ? card.dataset.tailles.split(',').filter(Boolean) : [];
      var pierres = card.dataset.pierres ? card.dataset.pierres.split(',').filter(Boolean) : [];
      var genres  = card.dataset.genres  ? card.dataset.genres.split(',').filter(Boolean)  : [];

      var ok = (!state.query   || title.includes(state.query))
            && price >= mn && price <= mx
            && (state.tailles.length === 0 || state.tailles.some(function (t) { return tailles.indexOf(t) !== -1; }))
            && (state.pierres.length === 0 || state.pierres.some(function (p) { return pierres.indexOf(p) !== -1; }))
            && (state.genre === ''         || genres.indexOf(state.genre) !== -1);

      card.classList.toggle('hidden', !ok);
      if (ok) visible++;
    });

    var label = visible + ' bracelet' + (visible !== 1 ? 's' : '');
    if (countEl)     countEl.textContent     = label;
    if (countMobile) countMobile.textContent = label;
    if (applyBtn)    applyBtn.textContent    = 'Voir ' + label;
    if (emptyState)  emptyState.style.display = visible === 0 ? 'block' : 'none';
    grid.style.display = visible === 0 ? 'none' : 'grid';

    updateBadge();
  }

  // ══════════════════════════════════════════════════════════
  // BADGE
  // ══════════════════════════════════════════════════════════
  function updateBadge() {
    if (!filterBadge) return;
    var n = state.tailles.length + state.pierres.length
          + (state.priceMin > 0 || state.priceMax < globalMax ? 1 : 0)
          + (state.query ? 1 : 0)
          + (state.genre ? 1 : 0);
    filterBadge.textContent = n;
    filterBadge.style.display = n > 0 ? 'inline-flex' : 'none';
    if (openBtn) openBtn.classList.toggle('has-filters', n > 0);
  }

  // ══════════════════════════════════════════════════════════
  // RESET
  // ══════════════════════════════════════════════════════════
  function doReset() {
    state.query    = '';
    state.priceMin = 0;
    state.priceMax = globalMax;
    state.tailles  = [];
    state.pierres  = [];
    state.genre    = '';

    if (searchInput) searchInput.value = '';
    if (inputMin)    inputMin.value = 0;
    if (inputMax)    inputMax.value = globalMax;
    updatePriceBar(0, globalMax);

    document.querySelectorAll('.bf-filter-check').forEach(function (cb) { cb.checked = false; });

    // Reset pills : remettre "Tous" actif partout
    document.querySelectorAll('.bf-genre-pill').forEach(function (p) {
      p.classList.toggle('active', p.dataset.genre === '');
    });

    var sfMin = document.getElementById('sf-min');
    var sfMax = document.getElementById('sf-max');
    if (sfMin) sfMin.value = 0;
    if (sfMax) sfMax.value = globalMax;

    applyFilters();
  }

  if (resetBtn)   resetBtn.addEventListener('click', doReset);
  if (resetEmpty) resetEmpty.addEventListener('click', doReset);

  // ══════════════════════════════════════════════════════════
  // TOGGLE GRILLE
  // ══════════════════════════════════════════════════════════
  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      grid.classList.toggle('cols-2', btn.dataset.view === '2');
    });
  });

})();

/* ── Genre pills — à ajouter à la fin de bracelet-filter.css ── */